import { createGlobalRoute } from '@townsquare/router/create-route';

export const notFoundRoute = createGlobalRoute({
	exact: true,
	name: 'not-found',
	path: '',
});
